/**
 * BET_TASK 缓存工具函数
 * 独立文件，避免导入时触发组件样式加载
 */

// ==================== Bet 加速模式结束时间计算（使用缓存）====================

/** bet 加速模式结束时间缓存 key */
const DOUBLE_BET_END_TIME_CACHE_KEY = "bet-activity-double-bet-end-time";
/** bet 加速服务器秒数缓存 key（用于检测服务器数据是否变化） */
const DOUBLE_BET_SECONDS_CACHE_KEY = "bet-activity-double-bet-seconds";

/**
 *  根据服务器秒数创建并缓存 bet 加速结束时间（由 subscribe 调用）
 * 只有在服务器秒数发生变化时才更新缓存，避免倒计时跳动
 */
export const setCachedDoubleBetFromSeconds = (
  balanceWarningExpireSeconds: number
): void => {
  try {
    // 检查服务器秒数是否发生变化
    const cachedSeconds = localStorage.getItem(DOUBLE_BET_SECONDS_CACHE_KEY);
    if (cachedSeconds === String(balanceWarningExpireSeconds)) {
      // 服务器秒数未变化，不更新缓存
      return;
    }

    const endTime = Date.now() + balanceWarningExpireSeconds * 1000;

    localStorage.setItem(DOUBLE_BET_END_TIME_CACHE_KEY, String(endTime));
    localStorage.setItem(
      DOUBLE_BET_SECONDS_CACHE_KEY,
      String(balanceWarningExpireSeconds)
    );
  } catch {
    // ignore
  }
};

// ==================== 普通 Bet 活动结束时间计算（使用缓存）====================

/** 普通 bet 活动结束时间缓存 key */
const BET_ACTIVITY_END_TIME_CACHE_KEY = "bet-activity-end-time";
/** 普通 bet 活动服务器秒数缓存 key（用于检测服务器数据是否变化） */
const BET_ACTIVITY_SECONDS_CACHE_KEY = "bet-activity-seconds";

/**
 * 只有在服务器秒数发生变化时才更新缓存，避免倒计时跳动
 */
export const setCachedBetActivityFromSeconds = (
  countdownSeconds: number
): void => {
  try {
    // 检查服务器秒数是否发生变化
    const cachedSeconds = localStorage.getItem(BET_ACTIVITY_SECONDS_CACHE_KEY);
    if (cachedSeconds === String(countdownSeconds)) {
      return;
    }

    const endTime = Date.now() + countdownSeconds * 1000;
    localStorage.setItem(BET_ACTIVITY_END_TIME_CACHE_KEY, String(endTime));
    localStorage.setItem(
      BET_ACTIVITY_SECONDS_CACHE_KEY,
      String(countdownSeconds)
    );
  } catch {
    // ignore
  }
};

// ==================== 明天0点倒计时计算（使用缓存）====================

/** 明天0点倒计时结束时间缓存 key */
const TOMORROW_END_TIME_CACHE_KEY = "bet-activity-tomorrow-end-time";
/** 明天0点倒计时服务器秒数缓存 key（用于检测服务器数据是否变化） */
const TOMORROW_SECONDS_CACHE_KEY = "bet-activity-tomorrow-seconds";

/**
 * ✅ 根据服务器秒数创建并缓存明天0点结束时间（由 subscribe 调用）
 * 只有在服务器秒数发生变化时才更新缓存，避免倒计时跳动
 */
export const setCachedTomorrowFromSeconds = (
  tomorrowCountdownSeconds: number
): void => {
  try {
    // 检查服务器秒数是否发生变化
    const cachedSeconds = localStorage.getItem(TOMORROW_SECONDS_CACHE_KEY);
    if (cachedSeconds === String(tomorrowCountdownSeconds)) {
      // 服务器秒数未变化，不更新缓存
      return;
    }

    const endTime = Date.now() + tomorrowCountdownSeconds * 1000;
    localStorage.setItem(TOMORROW_END_TIME_CACHE_KEY, String(endTime));
    localStorage.setItem(
      TOMORROW_SECONDS_CACHE_KEY,
      String(tomorrowCountdownSeconds)
    );
  } catch {
    // ignore
  }
};
